import {
    addComposeLinkViewState,
    removeAllComposeLinkViewStates,
    previewSharePointDocumentLinkInSxS,
} from './actions/publicActions';
import { createSharingLinkView } from './components/Link';
import showLinkContextMenu, {
    closeLinkContextMenu,
    LINK_CONTEXT_MENU,
} from './components/LinkContextMenu';
import { displaySpinnerOverlay } from './components/SpinnerOverlay';
import './mutators';
import getComposeLinkViewState from './selectors/getComposeLinkViewState';
import isContextMenuOpen from './selectors/isContextMenuOpen';

export { isBeautifulLinkBasedOnId, addBeautifiedPrefixToId } from './utils/beautifiedPrefix';
export { OWA_AUTO_LINKS_CLASSNAME } from './utils/constants';
export {
    addComposeLinkViewState,
    getComposeLinkViewState,
    createSharingLinkView,
    isContextMenuOpen,
    showLinkContextMenu,
    removeAllComposeLinkViewStates,
    closeLinkContextMenu,
    displaySpinnerOverlay,
    LINK_CONTEXT_MENU,
    previewSharePointDocumentLinkInSxS,
};
